import * as yup from 'yup';

export const userValidationSchema = yup.object().shape({
    firstName: yup.string().required('First name is required field'),
    lastName: yup.string().required('Last name is required field'),
  phoneNumber: yup.string().required('Phone number is required field'),
});
